import { createBrowserRouter, Navigate } from 'react-router-dom'
import Home from '@/pages/home'
import Intro from '@/pages/intro'
import Industry from '@/pages/industry'
import SystemCert from '@/pages/systemCert'
import CooperationCase from '@/pages/cooperationCase'
import News from '@/pages/news/index'
import NewsDetail from '@/pages/news/detail'
import Contact from '@/pages/contact'
import Entry from '@/pages/entry'

// 全局路由
export const globalRouters = createBrowserRouter([
  {
    // 布局路由：Header + 内容 + Footer
    path: '/',
    element: <Entry />,
    children: [
      { index: true, element: <Home /> },
      { path: 'home', element: <Home /> },
      { path: 'intro', element: <Intro /> },
      { path: 'industry', element: <Industry /> },
      { path: 'systemCert', element: <SystemCert /> },
      { path: 'cooperationCase', element: <CooperationCase /> },
      { path: 'news', element: <News /> },
      // 新闻详情：/news/detail/:id
      { path: 'news/detail/:id', element: <NewsDetail /> },
      { path: 'contact', element: <Contact /> },
    ],
  },
  // 未匹配，兜底到首页
  { path: '*', element: <Navigate to="/home" replace /> },
])

export default globalRouters